export const SET_TIMELINE_BANNER = 'TIMELINEBANNER/SET_TIMELINE_BANNER'
export const SET_TIMELINE_BANNERS = 'TIMELINEBANNER/SET_TIMELINE_BANNERS'
